module.exports = __webpack_public_path__ + "static/media/tourism.f46f7869.png";